import React, { useState } from "react";
const EditableFormContext = React.createContext(void 0);
const EditableFormProvider = ({ children }) => {
  const [editableFormId, setEditableFormIdInternal] = useState(null);
  function setEditableFormId(id) {
    setEditableFormIdInternal(null);
    setTimeout(() => {
      setEditableFormIdInternal(id);
    }, 100);
  }
  return /* @__PURE__ */ React.createElement(EditableFormContext.Provider, { value: { editableFormId, setEditableFormId } }, children);
};
export {
  EditableFormContext,
  EditableFormProvider
};
//# sourceMappingURL=EditProvider.js.map
